import React from 'react'
import './style.scss';


const Location = ({children,tag}) => {
  return (
    <div className="location-brand">
                <p className="brand">{tag}</p>
                <p className='location'>
                {children}
                </p>
              </div>
  )
}

export default Location